import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosNovedadesMixin = {
  computed: {
    permisosNovedades() {
      return {
        accesoModulo: tienePermiso('moduloNovedades'),
      };
    },
  },
};
